import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex)
//创建Store实例
const store = new Vuex.Store({
  // 存储状态值
  state: {
    visitedTagsExclude: [], // 需要清除缓存的页面
    visitedTags: JSON.parse(sessionStorage.getItem('visitedTags') || '[]'),
    loginStatus: localStorage.getItem('admin-token') ? true : false,
    isCollapse: false, // 是否收缩
    menuOwnMap: {}, // 用户的权限map
    onePage: '', // 第一页
    menuInitFlag: false, // 页面是否初始化完成 
  },
  // 状态值的改变方法,操作状态值
  // 提交mutations是更改Vuex状态的唯一方法
  mutations: {
    setVisitedTagsExclude(state, data) {
      state.visitedTagsExclude = data
    },
    // 重新设置tab路由路由
    setClearVisitedTags(state, data = {}) {
      let stData = {
        fullPath: data.fullPath,
        hash: data.hash,
        metaTitle: data.meta.title,
        name: data.name,
        path: data.path,
        query: data.query,
        keepAlive: data.keepAlive,
      }
      state.visitedTags = []
      state.visitedTags.push(stData)
      sessionStorage.setItem('visitedTags', JSON.stringify(state.visitedTags))
    },
    // 添加路由窗口
    setAddTags(state, payload) {
      console.log('payload', payload);
      // console.log('addTagsaddTagsaddTags', payload.route.meta.title);
      let flag = state.visitedTags.some(
        item => item.path === payload.sonItem.path
      ); //打开标签后，判断数组中是否已经存在该路由
      if (!flag) {
        state.visitedTags.push(
          Object.assign({}, {
            fullPath: payload.sonItem.fullPath,
            hash: payload.sonItem.hash,
            metaTitle: payload.sonItem.meta.title,
            name: payload.sonItem.name,
            path: payload.sonItem.path,
            query: payload.sonItem.query,
            keepAlive: payload.sonItem.keepAlive,
          })
        );
        sessionStorage.setItem('visitedTags', JSON.stringify(state.visitedTags))
      } //数组中路由存在不push ,单击左侧路由变化,点击标签路由变化均触发
    },
  },
  // 在store中定义getters（可以认为是store的计算属性）。Getters接收state作为其第一个函数
  getters: {

  },
  actions: {
    closeTags(state, payload) {
      let stas = state.state
      for (const [key, item] of stas.visitedTags.entries()) {
        console.log(key, item);
        if (item.path === payload.path) {
          stas.visitedTags.splice(key, 1);
          sessionStorage.setItem('visitedTags', JSON.stringify(stas.visitedTags))
          break;
        }
      }
    }
  }
})
// 要改变状态值只能通过提交mutations来完成
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js